import { MenuItem } from 'ts/types'
import {
  UserPage,
  UserTypePage
} from 'pages/Main'
import {
  GroupIcon,
  ShieldCheckIcon,
  SignOutIcon
} from 'components/svg'
import SignOutPage from 'pages/Auth/SignOutPage'

const menuItems: MenuItem[] = [
  {
    routeName: '/user',
    title: 'Users',
    icon: <GroupIcon />,
    component: UserPage
  },
  {
    routeName: '/user-type',
    title: 'User Type',
    icon: <ShieldCheckIcon />,
    component: UserTypePage
  },
  {
    routeName: '/sign-out',
    title: 'Sign Out',
    icon: <SignOutIcon />,
    component: SignOutPage
  }
]
export const ProductItems: MenuItem[] = []
export const LayoutItems: MenuItem[] = []
export const ClassItems: MenuItem[] = []
export const PriceItems: MenuItem[] = []
export const UserItems: MenuItem[] = [
  {
    routeName: '/user',
    title: 'Users',
    component: UserPage
  },
  {
    routeName: '/user-type',
    title: 'User Type',
    component: UserTypePage
  }
]
export const BottomItems: MenuItem[] = [
  {
    routeName: '/sign-out',
    title: 'Sign Out',
    icon: <SignOutIcon />,
    component: SignOutPage
  }
]

export default menuItems
